var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0002C24 5.37282 18.6274 0.000244141 12 0.000244141C5.37258 0.000244141 0 5.37282 0 12.0002C0 17.9897 4.3882 22.9542 10.125 23.8545V15.469H7.07812V12.0002H10.125V9.3565C10.125 6.349 11.9166 4.68774 14.6576 4.68774C15.9701 4.68774 17.3438 4.92212 17.3438 4.92212V7.87525H15.8306C14.34 7.87525 13.875 8.80032 13.875 9.75025V12.0002H17.2031L16.6711 15.469H13.875V23.8545C19.6118 22.9542 24 17.9897 24 12.0002Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.bc1283bda0c808e839504d880f39dec7.svg";
export { ForwardRef as ReactComponent };